export default __webpack_public_path__ + "static/media/goshen98.91d11b9e.jpg";